var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTi3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_72_1",
    "data-name": "Component 72 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#8672f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459",
    transform: "translate(14 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17672",
    "data-name": "Path 17672",
    d: "M340.924,346.249c-2.354-2.2-5.059-4.308-8.666-4.308-4.758,0-8.515,4.157-8.666,4.358a.525.525,0,0,0,0,.651c.15.2,3.907,4.358,8.666,4.358,4.608,0,7.714-3.606,8.615-4.308a.5.5,0,0,0,.05-.751Zm-8.666,3.256A2.865,2.865,0,0,1,329.4,346.6a2.9,2.9,0,0,1,2.855-2.905,2.94,2.94,0,0,1,2.905,2.905A2.907,2.907,0,0,1,332.258,349.5Z",
    transform: "translate(-309.017 -322.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17673",
    "data-name": "Path 17673",
    d: "M442.638,388.61a1.861,1.861,0,0,0-1.853,1.9,1.879,1.879,0,1,0,1.853-1.9Z",
    transform: "translate(-419.397 -366.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17674",
    "data-name": "Path 17674",
    d: "M362.73,22.91v6.712h6.662Z",
    transform: "translate(-345.95 -22.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17675",
    "data-name": "Path 17675",
    d: "M92.313,42.614a1.523,1.523,0,0,1,0-2c.15-.2,4.208-4.708,9.417-4.708h.5V25.834H94.767a.5.5,0,0,1-.5-.5V17.82H79.79a1.283,1.283,0,0,0-1.3,1.252v28.4a1.283,1.283,0,0,0,1.3,1.252h21.188a1.24,1.24,0,0,0,1.252-1.252v-.2h-.5c-5.209.05-9.266-4.458-9.417-4.658ZM82.6,21.276h7.764a.5.5,0,0,1,0,1H82.6a.5.5,0,0,1-.5-.5A.538.538,0,0,1,82.6,21.276Zm0,4.608h8.916a.5.5,0,1,1,0,1H82.6a.5.5,0,0,1-.5-.5A.538.538,0,0,1,82.6,25.884Zm0,4.608H98.123a.5.5,0,0,1,.5.5.539.539,0,0,1-.5.5H82.6a.5.5,0,0,1-.5-.5A.538.538,0,0,1,82.6,30.492Zm0,4.608H98.123a.5.5,0,1,1,0,1H82.6a.5.5,0,0,1-.5-.5A.538.538,0,0,1,82.6,35.1Zm7.713,10.218H82.6a.473.473,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.714a.5.5,0,1,1,0,1Zm0-4.608H82.6a.5.5,0,1,1,0-1h7.714a.5.5,0,1,1,0,1Z",
    transform: "translate(-78.488 -17.82)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTi3);
export default __webpack_public_path__ + "static/media/ti3.c0ccc5ee523d15e56c5eb41629675a4e.svg";
export { ForwardRef as ReactComponent };